// import "../public/styles.css";
function Header(){
    return (
    <header>
    <h1 className="header">Notekeep </h1>
    </header>
    )
}

export default Header;